<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import CompanyForm from "./components/CompanyForm.vue"

defineProps<{
  company: {
    id?: number | null
    name: string
    trade_name: string
    cnpj: string
    email: string
    phone: string
    website: string
    state_registration: string
    municipal_registration: string
    logo_url?: string | null
    addresses: Array<{
      id?: number | null
      label: "fiscal" | "fisico"
      street: string
      number: string
      complement: string
      district: string
      city: string
      state: string
      zip_code: string
    }>
  }
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <CompanyForm
      mode="create"
      title="Nova empresa"
      subtitle="Cadastre uma nova empresa para uso no sistema."
      :company="company"
      :errors="errors"
    />
  </AppShell>
</template>
